export default __webpack_public_path__ + "static/media/fire1.a2652662.svg";